module.exports = __webpack_public_path__ + "media/images/btn_facebook-3cab6a25e6958b4319604226490864bd.png";